import { lazy } from "react";

export { MY_ASSETS_PATH } from "./my-assets-path";
export const MyAssetsPage = lazy(() => import("./my-assets"));
